import { useAppDispatch, useAppSelector } from "app/hooks"
import { ILoginWithEmailPayload } from "./types"
import { createFitProfile, getFitProfile, loginWithEmail } from "./authSlice"
import { useFailed } from "features/notification/hooks"
import { useEffect } from "react"
import { IProfile } from "features/profile/profileTypes"

export const useLoginWithEmail = () => {
  const loginWithEmailLoading = useAppSelector(
    (state) => state.auth.loginWithEmailLoading,
  )
  const loginWithEmailFailed = useAppSelector(
    (state) => state.auth.loginWithEmailFailed,
  )
  const loginWithEmailSuccess = useAppSelector(
    (state) => state.auth.loginWithEmailSuccess,
  )

  const dispatch = useAppDispatch()
  const handleLoginWithEmail = (payload: ILoginWithEmailPayload) => {
    dispatch(loginWithEmail(payload))
  }

  return {
    loginWithEmailLoading,
    loginWithEmailFailed,
    loginWithEmailSuccess,
    handleLoginWithEmail,
  }
}

export const useFitProfile = () => {
  const getFitProfileLoading = useAppSelector(
    (state) => state.auth.getFitProfileLoading,
  )
  const getFitProfileFailed = useAppSelector(
    (state) => state.auth.getFitProfileFailed,
  )
  const fitProfile = useAppSelector((state) => state.auth.fitProfile)
  const isNotHasFitProfileYet = useAppSelector(
    (state) => state.auth.isNotHasFitProfileYet,
  )

  const dispatch = useAppDispatch()

  useFailed(getFitProfileFailed)

  useEffect(() => {
    if (!fitProfile) {
      dispatch(getFitProfile())
    }
  }, [])

  return {
    getFitProfileLoading,
    getFitProfileFailed,
    fitProfile,
    isNotHasFitProfileYet,
  }
}

export const useCreateFitProfile = () => {
  const createFitProfileLoading = useAppSelector(
    (state) => state.auth.createFitProfileLoading,
  )
  const createFitProfileFailed = useAppSelector(
    (state) => state.auth.createFitProfileFailed,
  )
  const createFitProfileSuccess = useAppSelector(
    (state) => state.auth.createFitProfileSuccess,
  )

  const dispatch = useAppDispatch()

  const handleCreateFitProfile = ({
    profile,
    isSubscribeUpdate,
  }: {
    profile: IProfile
    isSubscribeUpdate: boolean
  }) => {
    dispatch(createFitProfile({ profile, isSubscribeUpdate }))
  }

  useFailed(createFitProfileFailed)

  return {
    createFitProfileLoading,
    createFitProfileFailed,
    createFitProfileSuccess,
    handleCreateFitProfile,
  }
}
